import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import AutorenewRoundedIcon from '@mui/icons-material/AutorenewRounded';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';

import Icon from '@mui/material/Icon';

import { Drawer, Divider, Popover, Button } from '@mui/material';

import ArrowTooltipComponent from './ArrowTooltip';
import ArrowTooltipCss from './ArrowTooltipCss';
import Search from './Search';
import CommonStyles from './CommonStyles';
import ComponentWrapper from './ComponentWrapper';

//import HeaderWithSnow from './MenuWrapperSnow';

import { setDefaultJels, updateJelsSimple, updateJels } from '../reducer/jelsReducer';
import {
  setLoadedFlag,
  setSetupData,
  updateSetupTbox,
  updateAccountsTbox,
  updateSetupAccounts,
  updateLightMetaAndOps,
  updateSetupRestrictions,
  updateMetaImportsAndIntents,
} from '../reducer/metaReducer';

const gradientButtonStyle = {
  display: 'flex',
  alignItems: 'center',
  padding: '6px 16px',
  width: 'fit-content',
  textTransform: 'none',
  borderRadius: '20px',
  position: 'relative',
  boxSizing: 'border-box',
  color: '#FFF',
  transition: '0.5s',
  backgroundImage: 'linear-gradient(to left, #f79d00 0%, #44CF6B 40%, #F19500 100%)',
  backgroundSize: '200% auto', // Allow the gradient to be animated
  color: 'white',
  boxShadow: '0 0 20px #eee',
  cursor: 'pointer',
  '&:hover': {
    backgroundPosition: 'center right', // Change the background position to animate the gradient
    color: '#fff',
    textDecoration: 'none',
  },
};


const BalancePopover = ({
  setup,
  opened,
  account,
  classes,
  onClose,
  getMenu,
  hasPayments,
  paymentsData,
  setupBalance,
  balanceAnchor,
  getPaymentsData,
  minimalTopUpDue,
  getAccountPlanData,
  currentMonthDueData,
  statementBalanceDue,
  getSetupBalanceData,
}) => {
  const [refreshingBalance, setRefreshingBalance] = useState(false);

  const currentMonth = new Date().getMonth();
  const nextMonth = currentMonth + 1 > 11 ? 0 : currentMonth + 1;

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const currentMonthName = monthNames[currentMonth];
  const nextMonthName = monthNames[nextMonth];

  const SETUP_ID = setup.id;
  const ACC_ID = account.id;

  return (
    <Popover
      id="balance-popover"
      anchorEl={balanceAnchor}
      open={opened}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      PaperProps={{
        style: {
          marginTop: '25px',
          background: 'rgba(255, 255, 255, 0.7)',
          borderRadius: '16px',
          boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
          backdropFilter: 'blur(7px)',
          '-webkit-backdrop-filter': 'blur(7px)',
          border: '1px solid rgba(255, 255, 255, 0.8)',
        },
      }}
      onClose={onClose}
      disableRestoreFocus
      disableScrollLock
    >
      <div className={classes.column} style={{ padding: '20px', color: '#4c4c4c', lineHeight: 2 }}>
        <div className={`${classes.column}`}>
          <span className={`${classes.pl5}`} style={{ fontWeight: 500 }}>Available Cash: <strong>${setupBalance}</strong></span>
          <span className={`${classes.pl5}`} style={{ fontWeight: 500 }}>Statement Balance Due: <strong style={{ color: minimalTopUpDue > 0 ? '#DD5900' : '' }}>${minimalTopUpDue}</strong></span>

          <div className={`${classes.alignCenter} ${classes.mt10} ${classes.mb5}`}>
            <Button
              sx={gradientButtonStyle}
              onClick={() => {
                window.open(`https://buy.stripe.com/eVabKh6mVaTZcNi000?client_reference_id=${SETUP_ID}_${ACC_ID}`, '_blank', 'noreferrer noopener')
              }}
            >
              Refill Balance
              <ArrowForwardIosRoundedIcon
                style={{
                  fontSize: 12,
                  color: '#ffff',
                  marginLeft: '3px',
                }}
              />
            </Button>

            <ArrowTooltipCss text="Refresh balance" placement="left">
              <Button
                onClick={() => {
                  setRefreshingBalance(true);
                  (() => {
                    getMenu(), 
                    setTimeout(() => {
                      getSetupBalanceData();
                      getPaymentsData();
                      getAccountPlanData();
                      setRefreshingBalance(false);
                    }, 500);
                  })();
                }}
                className={`${classes.billingFirstBtnWhite} ${classes.ml10}`}
              >
                <AutorenewRoundedIcon
                  className={`${refreshingBalance ? classes.spinIcon : ''}`}
                  style={{
                    fontSize: 15,
                    color: '#222029',
                  }}
                />
              </Button>
            </ArrowTooltipCss>
          </div>

          {/* {(minimalTopUpDue && (setupBalance < minimalTopUpDue)) ?
            <div className={`${classes.mt10} ${classes.pl5} ${!currentMonthName ? classes.mb10 : ''}`}>
              <span style={{ color: '#DD5900' }}>Add <strong>${minimalTopUpDue - setupBalance}</strong> by {nextMonthName}&nbsp;1 to avoid suspension</span>
            </div>
          : null} */}
          {hasPayments ? null :
            <div
              className={`${classes.mt10} ${classes.column}`}
              style={{ lineHeight: 1.5, padding: '3px 8px', border: '1px dashed #81c056', backgroundColor: '#81c05640' }}
            >
              <div className={classes.alignCenter}>
                <span style={{ fontSize: 15 }}>{"\uD83D\uDE80"}</span>&nbsp;&nbsp;
                  <strong>First Refill Bonus:</strong><span>&nbsp;Your first top-up amount will double!</span>
              </div>
              <span>The funds you add will be increased by the same amount</span>
              {/* <span>resulting in double your Available Cash.</span> */}
            </div>
          }
        </div>

        {currentMonthDueData ?
          <div
            className={`${classes.column}`}
            style={{ backgroundColor: '#F6F6FF', margin: '16px -20px', borderBottom: '1px solid #fff', padding: '16px 25px 16px 20px', boxShadow: '#E3E1F0 0px 1px 1px inset' }}
          >
            <span className={`${classes.pl5}`} style={{ color: '#4c4c4c' }}>Used so far in&nbsp;{currentMonthName}:</span>
            <span className={`${classes.pl5}`}><strong>${currentMonthDueData.amount}</strong>&nbsp;total: <strong>
              {currentMonthDueData.drivers}</strong> {`${currentMonthDueData.drivers === 1 ? 'truck' : 'trucks' }`} operated x <strong>
                ${currentMonthDueData.price}</strong> per truck
            </span>
            
            {paymentsData && Object.values(paymentsData).length >= 1 ?
              <a
                href={`/frm?id=445`} //`/tbl?id=61907570`
                className={`${classes.billingSecondBtn} ${classes.mt10}`}
                style={{ backgroundColor: '#F6F6FF' }}
              >
                Usage and Charges
                <ArrowForwardIosRoundedIcon
                  style={{
                    fontSize: 12,
                    color: '#009587',
                    marginLeft: '3px',
                  }}
                />
              </a>
            : null}

          </div>
        : null}

        <a
          href={`/frm?id=447`} //`/tbl?id=61454472`
          className={`${classes.billingSecondBtn}`}
          style={{ margin: '8px 0', marginTop: currentMonthName ? '' : '16px' }}
        >
          Billing history
          <ArrowForwardIosRoundedIcon
            style={{
              fontSize: 12,
              color: '#009587',
              marginLeft: '3px',
            }}
          />
        </a>

        <a
          target="_blank" rel="noreferrer"
          href={`https://www.milkyweb.ai/#Pricing2`}
          className={`${classes.billingSecondBtn}`}
        >
          Pricing
          <ArrowForwardIosRoundedIcon
            style={{
              fontSize: 12,
              color: '#009587',
              marginLeft: '3px',
            }}
          />
        </a>

      </div>
    </Popover>
  )
};

class MenuWrapper extends ComponentWrapper {
  state = {
    menu: [],
    loaded: false,
    accPlanPaid: true,
    hasPayments: false,
    drawerIsOpen: false,
    balanceAnchor: null,
    paymentsData: null,
    minimalTopUpDue: null,
    statementBalanceDue: null,
    currentMonthDueData: null,
    balancePopoverOpened: false,
  };

  componentDidMount() {
    const search = window.location.pathname.split('/');
    const location = search[1];

    if (location === "unsubscribe") {
      this.setState({ loaded: true });
      return;
    }

    this.getMenu();
    
    switch (location) {
      case "ui_edit":
        (async() => {
          await this.props.updateJels();
          await this.props.updateSetupAccounts();
          await this.props.updateAccountsTbox();
          await this.props.updateLightMetaAndOps();
          await this.props.setLoadedFlag(true);
        })();
        break;
      case "accounts":
        this.props.updateLightMetaAndOps();
        break;
      case "playground":
        this.props.updateLightMetaAndOps();
        break;
      case "actions_log":
        this.props.updateSetupAccounts();
        this.props.updateLightMetaAndOps();
        break;
      case "matching":
        this.props.updateLightMetaAndOps();
        break;
      case "dashboard":
        this.props.updateJelsSimple();
        break;
      case "imports":
        this.props.updateJelsSimple();
        this.props.updateMetaImportsAndIntents();
        break;
      case "parsers":
        this.props.updateSetupTbox();
        break;
      case "cron":
        this.props.updateLightMetaAndOps();
        break;
      case "trpls":
        this.props.updateLightMetaAndOps();
        break;
      case "validator":
        this.props.updateLightMetaAndOps();
        break;
      default:
        //console.log("not updated redux")
    }
  };

  toggleDrawer = () => {
    this.setState({ drawerIsOpen: !this.state.drawerIsOpen });
  };

  getMenu = () => {
    this.get({
      url: '/get_jel?type=["def_frms"]&meta_query=["menu", "account", "setup", "macro_types"]',
      cb: (res) => {
        if (!res) {
          this.setState({ loaded: true });
        } else {
          const { menu, account, setup, macro_types } = res._meta_query;
          const { def_frms } = res;

          const aiUser = window.location.host === 'mlkwb.ai' || account && account.is_ai;

          this.setState(
            {
              menu,
            },
            () => {
              this.updateMeta({
                account,
                setup,
                macro_types,
              });
              if (aiUser) {
                this.getSetupBalanceData();
                this.getAccountPlanData();
                this.getPaymentsData();
              }
              if (def_frms) this.props.setDefaultJels(def_frms);
            }
          );
        }
      },
      errorCb: () => this.setState({ loaded: true }),
      disableNotify: true,
    });
  };

  updateMeta = (setupData) => {
    const { account, setup, macro_types } = setupData;
    this.props.setSetupData(account, setup, macro_types);

    this.setState({
      loaded: true,
    });
  };

  getAccountPlanData = () => {
    const { setup } = this.props;

    const reqData = {
      nesting: 1,
      api_key: setup.id,
      filter: {
        limit: 1,
        ancestor: 26779687,
      },
    };

    this.postWithData({
      url: `/pnkqry3`,
      data: reqData,
      cb: (res) => {
        if (res && res._status === 'ok' && res.trpls && Object.values(res.trpls).length) {
          const trplsValues = Object.values(res.trpls);

          const accPlanPaid = trplsValues[0] && trplsValues[0][2094] && trplsValues[0][2094][0].val ? true : false;

          setTimeout(() => {
            this.setState({ accPlanPaid });
          }, 1000)
        }
      },
    });
  };

  getPaymentsData = () => {
    const { setup } = this.props;

    const reqData = {
      nesting: 1,
      api_key: setup.id,
      filter: {
        limit: 3000,
        ancestor: 61454472,
      },
    };

    this.postWithData({
      url: `/pnkqry3`,
      data: reqData,
      cb: (res) => {
        if (res && res._status === 'ok' && res.trpls && Object.values(res.trpls).length) {

          const hasPayments = Object.values(res.trpls).some(paymentTrpls => paymentTrpls[2063]
            && paymentTrpls[2063][0].val.toUpperCase() === 'stripe'.toUpperCase());

          this.setState({ hasPayments });
        }
      },
    });
  };

  getSetupBalanceData = () => {
    const { setup } = this.props;

    const reqData = {
      nesting: 3,
      api_key: setup.id,
      filter: {
        limit: 3000,
        ancestor: 61907570,
      },
    };

    this.postWithData({
      url: `/pnkqry3`,
      data: reqData,
      cb: (res) => {
        if (res && res._status === 'ok') {
          const currentDate = new Date();
          const currentYear = currentDate.getFullYear();
          const currentMonth = currentDate.getMonth() + 1;

          const paymentsData = {};
          let statementBalanceDue = 0;
          let minimalTopUpDue = 0;
          let currentMonthDueData = { month: currentMonth, amount: 0, drivers: 0, price: 10 };

          if (res.trpls) Object.values(res.trpls).forEach((monthTrplsData, index) => {
            const year = monthTrplsData[2072] ? monthTrplsData[2072][0].val : currentYear;
            const month = monthTrplsData[2073] && monthTrplsData[2073][0] && monthTrplsData[2073][0].val ? monthTrplsData[2073][0].val : currentMonth;
            const amount = monthTrplsData[2074] ? monthTrplsData[2074][0].val : 0;
            const drivers = monthTrplsData[2075] ? monthTrplsData[2075][0].val : 0;
            const paid = monthTrplsData[2077] ? monthTrplsData[2077][0].val : false;
            const price = amount/drivers;

            paymentsData[Object.keys(res.trpls)[index]] = { year, paid, month, amount, drivers };

            if (month === currentMonth && year === currentYear) currentMonthDueData = { month, amount, drivers, price: price && Number.isInteger(price) ? price : 10 };

            if (((month !== currentMonth) || (year !== currentYear)) && !paid) minimalTopUpDue += amount;

            if (!paid) statementBalanceDue += amount;
          });

          this.setState({ statementBalanceDue, minimalTopUpDue, currentMonthDueData, paymentsData });
        }
      },
    });
  };

  changeBalancePopover = (e) => {
    const isOpened  = !this.state.balancePopoverOpened;
    this.setState({ balancePopoverOpened: isOpened, balanceAnchor:  isOpened ? e.currentTarget : null });

    this.getSetupBalanceData();
    this.getPaymentsData();
    this.getAccountPlanData();
  };

  getMenuList = () => {
    const { menu } = this.state;
    const { classes } = this.props;

    if (!menu) return null;

    return menu.map((menuArr, menuArrIndex) => {
      if (!Object.keys(menuArr).length) return null;

      const isLastElement = menuArrIndex === menu.length - 1;

      return (
        <div key={menuArrIndex}>
          <List style={{ paddingTop: '5px', paddingBottom: '5px' }}>
            {menuArr.title ? <div className={classes.menuHeading}>{menuArr.title}</div> : null}

            {menuArr.buttons &&
              menuArr.buttons.map((menuItem, menuItemIndex) => {
                return (
                  <a
                    key={menuItemIndex}
                    href={menuItem.url}
                    className={classes.pointer}
                    style={{
                      display: 'flex',
                    }}
                  >
                    <ListItem
                      button
                      style={{
                        paddingLeft: `${menuItem.icon ? '14px' : '45px'}`,
                      }}
                      className={classes.listItem}
                    >
                      {menuItem.icon ? (
                        <ListItemIcon classes={{ root: classes.listItemIcon }}>
                          <Icon className={classes.icon}>{menuItem.icon}</Icon>
                        </ListItemIcon>
                      ) : null}
                      <span className={classes.listText}>{menuItem.title}</span>
                    </ListItem>
                  </a>
                );
              })}
          </List>

          {!isLastElement ? <Divider light /> : null}
        </div>
      );
    });
  };

  render() {
    const { classes, account, setup } = this.props;
    const {
      menu,
      loaded,
      hasPayments,
      accPlanPaid,
      paymentsData,
      balanceAnchor,
      minimalTopUpDue,
      balancePopoverOpened,
      statementBalanceDue,
      currentMonthDueData
    } = this.state;

    const accountTitle =
      account && account.individual && account.individual.title
        ? account.individual.title
        : account
        ? account.login
        : '';
    
    const isAdmin = account && account.access_level > 1 ? true : false;
    const aiUser = window.location.host === 'mlkwb.ai' || account && account.is_ai;

    const setupBalance = setup && setup.hasOwnProperty('balance') ? setup.balance / 100 : 0;

    const balanceGeneral = setupBalance - minimalTopUpDue;

    return (
      <div>
        <Drawer
          anchor="left"
          classes={{
            paper: classes.drawer,
          }}
          open={this.state.drawerIsOpen}
          onClose={this.toggleDrawer}
        >
          <div tabIndex={0} role="button">
            {(menu && menu.length) ? this.getMenuList() : null}
          </div>
        </Drawer>

        {loaded ? (
          <React.Fragment>
            {account &&
            <div className={`${classes.header}`}>
              <div className={classes.alignCenter}>
                {(menu && menu.length) ? (
                  <div onClick={this.toggleDrawer} className={`${classes.burgerIconContainer} ${classes.pointer}`}>
                    <Icon className={`${classes.icon} material-icons`}>menu</Icon>
                  </div>
                ) : null}

                <a href="/dashboard" className={classes.mwLogo}>
                  <img
                    src={`${(window.location.host === 'mlkwb.ai' || (account && account.is_ai)) ? "/images/mwg.svg" : "/images/mwo.svg"}`}
                    alt="MW"
                    style={{
                      height: '20px',
                      marginLeft: '2px',
                      marginTop: '4px',
                    }}
                  />
                </a>
              </div>

              {/* <HeaderWithSnow/> */}

              <div style={{ alignSelf: 'stretch' }} className={classes.alignCenter}>
                {isAdmin ? <Search disableInputFocus showConcepts /> : null}

                {aiUser ?
                  <div className={`${classes.alignCenter} ${classes.nowrap} ${classes.ml20}`} style={{ zIndex: 10 }}>
                    {accPlanPaid ? null :
                      <ArrowTooltipComponent title={'Your account is on a Free plan now.<br>Some featues are restricted or not available.<br><strong>To remove restrictions, refill your Balance.</strong>'} placement="top" open={true}>
                        <ReportProblemRoundedIcon
                          className={`${classes.pointer} ${classes.mr5}`}
                          style={{ color: '#ffb300', fontSize: 20, marginTop: '2px' }}
                        />
                      </ArrowTooltipComponent>
                    }
                    <div
                      className={`${classes.alignCenter} ${classes.pointer} ${classes.balanceMenu} ${classes.nowrap}`}
                      onClick={(e) => this.changeBalancePopover(e)}
                      style={{ backgroundColor: balanceAnchor ? '#F1F1F6' : '' }}
                    >
                      <span className={`${classes.balance}`}>
                        Balance:&nbsp;
                      </span>
                      <span style={{ color: balanceGeneral < 0 ? '#DD5900' : '' }}>
                        {`${balanceGeneral < 0 ? '\u2212' : ''}`}
                      </span>
                      <span style={{ color: balanceGeneral < 0 ? '#DD5900' : '' }}>$</span>
                      <span style={{ color: balanceGeneral < 0 ? '#DD5900' : '' }}>{Math.abs(balanceGeneral)}</span>
                      <ArrowDropDownRoundedIcon
                        style={{
                          fontSize: 20,
                        }}
                      />
                    </div>
                    <div className={classes.menuDivider}></div>
                  </div>
                : null}

                <BalancePopover
                  setup={setup}
                  classes={classes}
                  account={account}
                  getMenu={this.getMenu}
                  hasPayments={hasPayments}
                  setupBalance={setupBalance}
                  balanceAnchor={balanceAnchor}
                  paymentsData={paymentsData}
                  opened={balancePopoverOpened}
                  minimalTopUpDue={minimalTopUpDue}
                  onClose={this.changeBalancePopover}
                  getPaymentsData={this.getPaymentsData}
                  getAccountPlanData={this.getAccountPlanData}
                  currentMonthDueData={currentMonthDueData}
                  statementBalanceDue={statementBalanceDue}
                  getSetupBalanceData={this.getSetupBalanceData}
                />

                {account && account.individual ? (
                  <ArrowTooltipCss placement="bottom" text={`${account.login}`}>
                    {isAdmin && !aiUser ? 
                      <a className={`${classes.accountLink} ${classes.nowrap}`} href={`/node/${account.individual.id}`}>
                        {accountTitle}
                      </a>
                    : <span className={`${classes.accountLink} ${classes.nowrap}`}>{accountTitle}</span>}
                  </ArrowTooltipCss>
                ) : account ? (
                  <span className={`${classes.account} ${classes.nowrap}`}>{accountTitle}</span>
                ) : <a className={classes.loginBtn} href='/auth'>Sign in</a>
                }
              </div>
            </div>
            }
            <main className={classes.content}>{this.props.children}</main>
          </React.Fragment>
        ) : (
          null
          // <div
          //   style={{
          //     display: 'flex',
          //     height: '100vh',
          //     alignItems: 'center',
          //     justifyContent: 'center',
          //     marginTop: '-40px'
          //   }}
          // >
          //   <BounceLoader isLoading={true} />
          // </div>
        )}
      </div>
    );
  }
};

const styles = {
  header: {
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    height: '40px',
    maxHeight: '40px',
    background: '#fff',
    display: 'flex',
    zIndex: 1100,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  burgerIconContainer: {
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      background: '#F2EEF6',
    },
  },
  drawer: {
    minWidth: '200px',
    ...CommonStyles.styledScroll,
    '&::-webkit-scrollbar': {
      width: '5px',
    },
  },
  icon: {
    fontSize: '20px !important',
    color: '#5B5762',
    '&:hover': {
      color: '#5B5762',
    },
  },
  listItem: {
    border: 'none',
    height: '38px',
    '&:hover': {
      background: '#EEECF8',
    },
  },
  listItemIcon: {
    marginRight: '11px',
    minWidth: '1px',
  },
  listText: {
    fontSize: '14px',
    color: '#4E4C4C',
  },
  mwLogo: {
    width: '40px',
    height: '40px',
    display: 'flex',
    color: '#FFFF',
    opacity: '0.95',
    fontSize: '18px',
    fontWeight: '400',
    alignItems: 'center',
    background: '#1B1920',
    justifyContent: 'center',
    '&:hover': {
      color: '#FFFF',
      opacity: '1',
      background: '#1B1920',
    },
  },
  menuHeading: {
    height: '32px',
    display: 'flex',
    fontSize: '16px',
    color: '#4E4C4C',
    fontWeight: '600',
    fontStyle: 'normal',
    textAlign: 'center',
    paddingLeft: '7px',
    alignItems: 'center',
  },
  accountLink: {
    color: '#222029',
    fontWeight: '600',
    lineHeight: '16px',
    padding: '0 20px 0 12px',
    opacity: '0.9',
    '&:hover': {
      opacity: '1',
    }
  },
  balance: {
    color: '#222029',
    fontWeight: '500',
    lineHeight: '16px',
    opacity: '0.9',
    '&:hover': {
      opacity: '1',
    }
  },
  account: {
    color: '#7D7D7D',
    fontSize: '12px',
    lineHeight: '16px',
    padding: '0 20px',
  },
  loginBtn: {
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'stretch',
    padding: '0 10px',
    backgroundColor: '#E1EFF2',
    cursor: 'pointer',
    color: '#72A5B0',
    fontSize: '15px',
    whiteSpace: 'nowrap',
  },
  menuDivider: {
    backgroundColor: '#E3E1F0',
    width: '1px',
    height: '24px',
    margin: '0 10px',
  },
  balanceMenu: {
    padding: '6px 8px 6px 12px',
    '&:hover': {
      backgroundColor: '#F1F1F6',
    }
  },
  billingSecondBtn: {
    display: 'flex',
    color: '#009587',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '1px 5px',
    width: 'fit-content',
    textTransform: 'none',
    '&:hover': {
      color: '#038b7e',
    },
  },
  billingFirstBtnWhite: {
    minWidth: '24px !important',
    fontSize: 12,
    padding: '6px',
    width: 'fit-content',
    textTransform: 'none',
    borderRadius: '20px',
    backgroundColor: '#E8E9F4',
    color: '#222029',
    opacity: '0.8',
    '&:hover': {
      opacity: '1.0',
      backgroundColor: '#E8E9F4',
      color: '#222029',
    },
  },
  '@keyframes spin': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' },
  },
  spinIcon: {
    animation: '$spin 1s infinite linear',
  },
  ...CommonStyles,
};

export default connect((state) => ({account: state.meta.account, setup: state.meta.setup}),
{ updateJels,
  setLoadedFlag,
  setSetupData,
  setDefaultJels,
  updateSetupTbox,
  updateJelsSimple,
  updateSetupAccounts,
  updateAccountsTbox,
  updateLightMetaAndOps,
  updateSetupRestrictions,
  updateMetaImportsAndIntents,
})(withStyles(styles)(MenuWrapper));
